import Render from "@Views/root/user/payment-method.html";
import {Component, Vue} from "vue-property-decorator";
import {notif, purchase, user} from '@Store/modules'
import {StripePayment} from "@Enums/stripe-payment";
import {IStripePaymentMethod} from "@Store/types/user";
import {INotification} from "@Store/types/notification";
import {Profile} from "@Enums/profile";

@Render
@Component({})
export class PaymentMethod extends Vue {

	mounted() {
		this.$emit('navigate', 'user-payment-method')
	}

	get stripePaymentMethod(): IStripePaymentMethod {
		return user.user.stripePaymentMethod
	}

	get isCard(): boolean {
		return this.stripePaymentMethod.type === StripePayment.Card;
	}

	get isSepa(): boolean {
		return this.stripePaymentMethod.type === StripePayment.Sepa;
	}

	get isExpired(): boolean {
		return this.stripePaymentMethod?.is_expired ?? false
	}

	get isDemo(): boolean {
		return !!location.hostname && location.hostname.startsWith('demo')
	}

	get canChangePaymentMethod(): boolean {
		return user.user.isChangePaymentMethodRequired
	}

	get paymentTitle(): string {
		const pm = this.stripePaymentMethod

		if(!pm) return ''

		if (this.isCard) {
			return `CB ....${pm.last4}`
		}
		if (this.isSepa) {
			return `Prélèvement SEPA ....${pm.last4}`
		}
		return ''

	}

	get cardExpirationText() {
		const pm = this.stripePaymentMethod
		if (!pm || !this.isCard) return ''

		const date = new Date(parseInt(pm.exp_year), parseInt(pm.exp_month) - 1)
		const formatter = new Intl.DateTimeFormat('fr-FR', { month: 'short', year: 'numeric' })
		const formattedDate = formatter.format(date)

		if (pm.is_expired) {
			return `A expiré le ${formattedDate}`
		}

		return `Expire le ${formattedDate}`
	}

	changePaymentMethod(): void {
		purchase.getPaymentMethodUpdateLink().then((url: string) => {
			window.location.href = url
		})
			.catch(() => {
				let notification: INotification = {message: this.$i18n.t('vm.root.user.payment-method.update-payment.failed').toString(), actions:[], delay: 5000, canClose: true}
				notif.error(notification)
			})
	}
}
